/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Save_TitleInputs */

const en_views_save_title = /** @type {(inputs: Views_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save view`)
};

const de_views_save_title = /** @type {(inputs: Views_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht speichern`)
};

/**
* | output |
* | --- |
* | "Save view" |
*
* @param {Views_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_save_title = /** @type {((inputs?: Views_Save_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Save_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_save_title(inputs)
	return en_views_save_title(inputs)
});